export default __webpack_public_path__ + "static/media/bg41.12c14fad.jpg";